module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('div', {
    staticClass: "display-2 primary--text pa-3"
  }, [_vm._v("Whoops, 404!")]), _vm._v(" "), _c('div', {
    staticClass: "pa-2"
  }, [_vm._v("The page you were looking for is temporarily unavailable or does not exist.")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/",
      "color": "primary",
      "outline": ""
    }
  }, [_vm._v("Get me out of here!")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29364b88","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = 953
// module chunks = 9